/* ==========================================================================
 *  Initialization Google maps
 * ======================================================================= */
function fn_components_google_map() {
	$(".map-block").each(function() {
		var inst = $(this);
		var id = inst.attr("id");
		var langitude = inst.data("langitude");
		var longitude = inst.data("longitude");
		fn_init_map(id, langitude, longitude);
	});
}

var map;

function fn_init_map(id, langitude, longitude) {
	var mapOptions = {
		center: new google.maps.LatLng(langitude, longitude),
		zoom: 17,
		zoomControl: true,
		disableDoubleClickZoom: false,
		mapTypeControl: false,
		scaleControl: true,
		scrollwheel: false,
		panControl: true,
		streetViewControl: false,
		draggable: true,
		overviewMapControl: false,
		overviewMapControlOptions: {
			opened: false
		},
		mapTypeId: google.maps.MapTypeId.ROADMAP,
		styles: [{featureType:"all",elementType:"labels.text.fill",stylers:[{saturation:36},{color:"#000000"},{lightness:"51"}]},{featureType:"all",elementType:"labels.text.stroke",stylers:[{visibility:"on"},{color:"#1f364d"},{lightness:"-25"}]},{featureType:"all",elementType:"labels.icon",stylers:[{visibility:"off"}]},{featureType:"administrative",elementType:"geometry.fill",stylers:[{color:"#ffffff"},{lightness:20}]},{featureType:"administrative",elementType:"geometry.stroke",stylers:[{color:"#ffffff"},{lightness:17},{weight:1.2}]},{featureType:"landscape",elementType:"geometry",stylers:[{color:"#1f364d"},{lightness:"0"}]},{featureType:"poi",elementType:"geometry",stylers:[{color:"#1f364d"},{lightness:"-7"}]},{featureType:"road.highway",elementType:"geometry.fill",stylers:[{color:"#1f364d"},{lightness:"-28"}]},{featureType:"road.highway",elementType:"geometry.stroke",stylers:[{color:"#1f364d"},{lightness:"-24"},{weight:.2}]},{featureType:"road.arterial",elementType:"geometry",stylers:[{color:"#1f364d"},{lightness:"-24"}]},{featureType:"road.local",elementType:"geometry",stylers:[{color:"#1f364d"},{lightness:"-25"}]},{featureType:"transit",elementType:"geometry",stylers:[{color:"#1f364d"},{lightness:"-41"}]},{featureType:"water",elementType:"geometry",stylers:[{color:"#1f364d"},{lightness:17}]}]
	};
	var mapElement = document.getElementById(id);
	map = new google.maps.Map(mapElement, mapOptions);

	var ua = window.navigator.userAgent;
	var msie = ua.indexOf("MSIE ");

	if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
		var markerImg = "images/map-marker.png";
	} else {
		var markerImg = "images/map-marker.svg";
	}

	var locations = [[langitude, longitude, markerImg]];
	for (i = 0; i < locations.length; i++) {
		marker = new google.maps.Marker({
			icon: locations[i][2],
			position: new google.maps.LatLng(locations[i][0], locations[i][1]),
			map: map
		});
	}


	if ($(window).width() > bp_small && id == "map-footer"){
		// var isMapCenter = false;
		google.maps.event.addListenerOnce(map, 'bounds_changed', function(){
			// if(!isMapCenter){
			offsetCenter(map.getCenter(), 300, 0);
			isMapCenter = true; 
			// }
		});
	}
}


function offsetCenter(latlng, offsetx, offsety) {

	var scale = Math.pow(2, map.getZoom());
	var nw = new google.maps.LatLng(
	    map.getBounds().getNorthEast().lat(),
	    map.getBounds().getSouthWest().lng()
	);

	var worldCoordinateCenter = map.getProjection().fromLatLngToPoint(latlng);
	var pixelOffset = new google.maps.Point((offsetx/scale) || 0,(offsety/scale) ||0)

	var worldCoordinateNewCenter = new google.maps.Point(
	    worldCoordinateCenter.x - pixelOffset.x,
	    worldCoordinateCenter.y + pixelOffset.y
	);

	var newCenter = map.getProjection().fromPointToLatLng(worldCoordinateNewCenter);

	map.setCenter(newCenter);

}